import React from "react";
import { Helmet } from "react-helmet";
import Banner from "../../../component/Banner";
import image1 from "../../../images/healthcare/healthcare4.webp";
import { Link } from "react-router-dom";
const Providers = () => {
  const banner = {
    title: "Providers",
    image: image1,
  };

  return (
    <>
      <Helmet>
        <title>
        Providers — Cylon Technologies – Big Data | Data Analytics | Digital Strategy
        </title>
      </Helmet>
      <Banner heading={banner.title} bannerimg={banner.image} />
      <section className="sec-padd page_content heading_space pb-5 small_ul">
        <div className="container">
          <div className="row g-md-5 g-4 justify-content-between">
            <div className="col-md-7">
              <h2 className="heading2">Healthcare Provider Services</h2>
              <p>
              Healthcare providers are considered as the primary channel or conduit of compassion in the healthcare sector. The majority of healthcare services are being provided through private companies and in some cases the government steps in with some safety nets for those people who have disabilities, are unemployed or live at or close to poverty levels.
              </p>
              <p>
              Over the past several years with the rapidly changing healthcare market scenario, Cylon Technologies healthcare provider solutions are helping you streamline operations while maximizing your investment. Our focus remains on providing you with services, solutions that you need to improve coordination, and collaboration to create a consumer focused environment that is interconnected, streamlined and efficient.
              </p>
              <p>
              Cylon Technologies believes that population health will have a huge impact on organizations and society as a whole within the next few years and as such, we had prepared various healthcare provider solutions to be implemented through various initiatives that are focused on your pressing needs. Our people, processes and connected solutions detect access and refine every stage of your healthcare journey.
              </p>
              <h5>
              Cylon Technologies   – Futuristic Solutions for Healthcare
              </h5>
                <p>The healthcare sector is growing rapidly with the adoption of innovative technologies that are offering scalable and interoperable solutions. These healthcare technologies have transformed the way healthcare is administered both from finance and care perspective. As renowned healthcare providers, we have capabilities in navigating through the complex issues such as tight margins, heightened regulations and reforms, new technologies and infrastructure issues.  </p>
                <h2 className="heading2">Our Capabilities as healthcare providers include –</h2>
                <p><b>Consulting Services -</b> Our business consulting services in healthcare would help you in developing highly effective, efficient ways of engaging, collaborating with your patients, cost management, and enablement of technology innovation.</p>
                <p><b>Technology Services -</b>  Cylon Technologies offers advanced IT and technology services that helps you improving patient safety with patient centric data by managing, measuring and monitoring individual care and in achieving clinical effectiveness.  Some of the services that we offer under the gamut of advanced technology  include-</p>
              <ul>
                <li>
                Clinical Data Integration
                </li>
                <li>
                Application Development, Support and Maintenance
                </li>
                <li>Business Process Services</li>
                <li>
                Enterprise Data Warehousing
                </li>
                <li>
                Infrastructure Services
                </li>
                <li>ICD-10  Remediation and Testing</li>
                <li>Quality Assurance</li>

              </ul>


            </div>
            <div className="col-md-4">
              <div className="right_content">
                <div className="border-tb mb-5">
                  <h2 className="heading2 mt-0">Offerings</h2>
                  <p>Cylon Technologies innovative solutions in digital health are resulting in giving our renowned customers more information about their health, and more control over their care. It also unlocks never before seen insight into patient health patterns and medication treatment effectiveness that leads to more informed healthcare decisions to everyone involved. Our digital healthcare services had becomes the catalyst for healthcare service providers and as such resulted in outcomes such as-</p>
                  <ul>
                    <li>
                    More engaged patients or customers
                    </li>
                    <li>Optimized Therapies</li>
                    <li>Improved outcomes</li>
                  </ul>
                  <p>With many stakeholders involved in digital health activities including patients, health care practitioners, researchers, medical device firms, as such Cylon technologies has adopted a wide ranging set of policies that are designed to help integrate the burgeoning field of mHealth into clinical practices. We have established the Digital Healthcare Program that seeks to better protect and promote patient healthcare and provides continued regulatory clarity by -</p>
                  <ul>
                    <li>
                    Developing  and Implementing regulatory strategies and policies for digital health technologies and
                    </li>
                    <li>Fostering partnerships/collaborations and enhancing the outreach to digital health customers. </li>
                    <li>Overall, our digital health services are capable of providing people with smart care in a homely environment.</li>
                  </ul>
                </div>



              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Providers;
